import { useRef, useEffect, useMemo, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useImmer } from 'immerable/useImmer';
import { NavMarker } from 'react-rhumb';
// @ts-expect-error untyped module
import NotificationList from 'ReduxMessenger/components/NotificationList';
import I18n from 'I18n';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIEditorPage from 'UIComponents/page/UIEditorPage';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UIEditorToolbar from 'UIComponents/nav/UIEditorToolbar';
import UITabBar from 'UIComponents/nav/UITabBar';
import { Panel } from 'foundations-components/transitional/components/Panel';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIButton from 'UIComponents/button/UIButton';
import Small from 'UIComponents/elements/Small';
import { KOALA } from 'HubStyleTokens/colors';
import { Text } from 'foundations-components/components/Text';
import { AutoSizedTextInput } from 'foundations-components/transitional/components/AutoSizedTextInput';

// @ts-expect-error untyped module
import UIOpt from 'ui-addon-opt/components/UIOpt';
// @ts-expect-error untyped module
import { OPTIN_VIEW_NEW } from 'ui-addon-opt/constants/UIOptConstants';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { getFlowName } from 'automation-ui-flow-core/flow/flowUtils';
import { UNKNOWN_ID, CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import LazyLangLoaderDecorator from 'automation-ui-i18n/LazyLangLoaderDecorator';
import flowContainerTranslations from 'i2l?query=sporks!automation-ui-canvas/lang/flow-container/en.lyaml';
import actionFeaturesTranslations from 'i2l?query=sporks!automation-ui-canvas/lang/action-features/en.lyaml';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import * as UsageTrackingScreens from 'automation-ui-usage-tracking/UsageTrackingScreens';
import { trackEvent, trackPageView } from 'automation-ui-canvas/utils/trackingUtils';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { CREATE_FROM_CANVAS } from 'automation-ui-canvas/constants/Gates';
import Routes from 'automation-ui-canvas/constants/Routes';
import { SIDE_PANEL_WIDTH } from 'automation-ui-core/constants/ui';
import { useCanvasTopOffset } from 'automation-ui-canvas/utils/styleUtils';
import CreatePanelContent from 'automation-ui-canvas/create/CreatePanelContent';
import CreateFlowPreviewCanvas from 'automation-ui-canvas/create/CreateFlowPreviewCanvas';
import provideAllSupportedResolvers from 'automation-ui-canvas/reference-resolvers/providers/provideAllSupportedResolvers';
import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import CreateFlowMenuBar from 'automation-ui-canvas/components/flow-header/menu-bar/CreateFlowMenuBar';
import PreloadSegmentationFilters from 'automation-ui-canvas/components/common/PreloadSegmentationFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CreateContainer({
  areLangStringsLoading
}) {
  var _flow$name;
  const [flow, setFlow] = useImmer({
    objectTypeId: UNKNOWN_ID,
    associatedLists: [],
    flowEventFilters: [],
    enrollmentTrigger: null,
    shouldReenroll: false,
    isClassicWorkflow: false
  });
  const scrollElementRef = useRef(undefined);
  const isUngatedToCreateFromCanvas = useIsUngated(CREATE_FROM_CANVAS);
  const history = useHistory();
  if (!isUngatedToCreateFromCanvas) {
    history.replace(Routes.CREATE_FLOW);
  }
  useEffect(() => {
    setDocumentTitle('createWorkflow.pageTitle');
    trackPageView(UsageTrackingScreens.CREATE);
  }, []);
  const canvasTopOffset = useCanvasTopOffset(scrollElementRef);
  const flowRecord = useMemo(() => new Flow(Object.assign({}, flow, {
    flowId: NaN
  })), [flow]);
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  return /*#__PURE__*/_jsxs(UIEditorPage, {
    headerComponent: /*#__PURE__*/_jsx(UIEditorToolbar, {
      startSlot: /*#__PURE__*/_jsx(UIBackButton, {
        onClick: () => {
          trackEvent(Trackables.CLICKED_BACK_TO_WORKFLOWS, undefined, true);
        },
        children: /*#__PURE__*/_jsx(UIRouterLink, {
          use: "on-dark",
          to: "/",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "list.sourceApps.backNavigation.default"
          })
        })
      }),
      titleText: /*#__PURE__*/_jsx(Text, {
        typography: "heading-200",
        as: "div",
        children: /*#__PURE__*/_jsx(AutoSizedTextInput, {
          use: "on-dark",
          affordance: true,
          placeholder: getFlowName({
            name: null
          }),
          value: (_flow$name = flow.name) !== null && _flow$name !== void 0 ? _flow$name : '',
          onChange: ({
            target: {
              value
            }
          }) => {
            setFlow(draftFlow => {
              draftFlow.name = value;
            });
          }
        })
      }),
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "edit.state.disabled"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          disabled: true,
          children: !areLangStringsLoading && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.reviewAndPublishButton"
          })
        })]
      })
    }),
    tabs: areLangStringsLoading ? /*#__PURE__*/_jsx(UITabBar, {
      bordered: true,
      startSlot: /*#__PURE__*/_jsx("div", {
        className: "p-all-6"
      })
    }) : /*#__PURE__*/_jsx(CreateFlowMenuBar, {
      flow: flowRecord,
      canvasScrollElementRef: scrollElementRef
    }),
    hasScrolling: true,
    mainSectionFlush: true,
    scrollDirection: "both",
    scrollElementRef: scrollElementRef,
    use: "default",
    mainBackgroundColor: KOALA,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "p-all-5",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "FLOW_CREATE_CONTAINER"
      }), /*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(CreateFlowPreviewCanvas, {
        areLangStringsLoading: areLangStringsLoading,
        flow: flowRecord,
        scrollElementRef: scrollElementRef
      })]
    }), /*#__PURE__*/_jsxs(Panel, {
      align: "left",
      "data-test-id": "create-flow-panel",
      position: "fixed",
      insetBlockStart: `${canvasTopOffset}px`,
      blockSize: `calc(100vh - ${canvasTopOffset}px)`
      /* This panel doesn't expand to fit the SegmentationFilters side panel,
       causing it to be invisible in Safari.
       https://git.hubteam.com/HubSpot/ProductSupport/issues/74490 */,
      overflow: "visible",
      width: SIDE_PANEL_WIDTH,
      containerZIndex: "800",
      children: [/*#__PURE__*/_jsx(CreatePanelContent, {
        flow: flow,
        setFlow: setFlow
      }), /*#__PURE__*/_jsx(PreloadSegmentationFilters, {
        objectTypeId: CONTACT_ID,
        delay: 1000
      })]
    }), /*#__PURE__*/_jsx(UIOpt, {
      optinName: "trigger-first-create-workflow-page",
      optinView: OPTIN_VIEW_NEW,
      onTargetOptinViewChanged: view => {
        if (view !== OPTIN_VIEW_NEW) {
          history.replace(Routes.CREATE_FLOW);
        }
      },
      tracker: usageTracker,
      optOutButtonText: I18n.text('createWorkflow.betaButtonText')
    })]
  });
}
export default LazyLangLoaderDecorator([flowContainerTranslations, actionFeaturesTranslations])(provideAllSupportedResolvers(CreateContainer));